import { render } from "./evolutionInscrpit.vue?vue&type=template&id=19830f9c"
import script from "./evolutionInscrpit.vue?vue&type=script&lang=js"
export * from "./evolutionInscrpit.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__